<template>
  <!-- READ ONLY MODE -->

  <div class="option-section" v-if="mode === 'VIEW'">
    <div class="question-container">
      <span class="step" v-if="showStep">Step {{ question.stepSequence }}</span>
      <p class="question_body ql-editor p-0" v-html="question.formattedBody"></p>
    </div>
    <select class="form-control type_select operator w-250 mb-35" disabled>
      <option value="undefined" selected disabled>Select an answer</option>
    </select>
  </div>

  <!-- EDIT MODE -->

  <div v-else-if="mode == 'EDIT'">
    <div class="p-0">
      <div @click="isAddHelpEnabled = !isAddHelpEnabled" class="th-activity-question-type-custom-scale-edit">
        <span
          class="add-help-text "
          :style="{
            color: isAddHelpEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Help
        </span>
      </div>
      <quill-editor class="bg-white mt-38" v-model="question.formattedBody" :disabled="question.type === 'Default'" :options="commonProps.editorOptionForQuestion"></quill-editor>
    </div>
    <!-- help content -->
    <div v-if="isAddHelpEnabled">
      <h5 class="answer">Help</h5>
      <quill-editor class="bg-white mt-30 mb-20" v-model="question.helpContent" :options="editorOptionForHelp" v-on:change="helpCharacterLimitValidation($event)"></quill-editor>
    </div>

    <h5 class="answer">Answers</h5>
    <div class="row form-group" v-for="(option, index) in question.options" :key="index">
      <div v-if="option.enabled !== false">
        <div :class="index > 1 ? 'col-sm-11 p-0' : 'col-sm-11 p-0'">
          <div v-if="activityDetails.customParticipantMessaging" v-on:click="deleteQuestionOptionMessageItem(question.options, index)" class="th-activity-question-type-multichoice-edit">
            <span
              class="add-message-text disable-text-selection"
              :style="{
                color: option.isAddMessageEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
              }"
            >
              Add Message
            </span>
          </div>
          <quill-editor class="bg-white mt-30 mb-10 quill-score" v-model="option.formattedBody" :options="editorOptionForAnswers" v-on:input="validateAnswerLimit(option.formattedBody)"></quill-editor>
        </div>
        <div class="col-lg-1 p-0 score_cls">
          <h5 class="score_text">Score</h5>
          <integer-plusminus :min="0" :max="999" :step="1" :vertical="false" :disabled="activityDetails && activityDetails.canScoreResponses == false" formName="score" class="score_input" v-model.number="option.score">
            <input v-model.number="option.score" oninput="javascript:this.value = Math.abs(this.value); this.value = Math.round(this.value); if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="3" value="999" type="number" class="integer-plus-minus-input text-left pl-4" />
          </integer-plusminus>
        </div>
        <div v-if="option.isAddMessageEnabled && activityDetails.customParticipantMessaging" class="row add_message_div">
          <div class="col-md-11 p-0">
            <h5 class="mt-10">Message</h5>
            <quill-editor class="bg-white mb-10 quill-score" v-model="option.messageBody" :options="editorOptionForMessage" @change="helpCharacterLimitValidation"></quill-editor>
          </div>
          <div class="col-md-1 p-0">
            <button class="btn btn-link color_red pl-0 pt-35" v-on:click="deleteQuestionOptionMessageItem(question.options, index)">
              <img alt="delete" src="static/img/delete.svg" />
            </button>
          </div>
        </div>
        <div class="col-sm-2 p-0" v-if="index > 1">
          <button class="btn btn-link color_red" v-on:click="deleteQuestionOptionItem(index)" v-if="index > 1">
            Remove
          </button>
        </div>
      </div>
    </div>
    <div class="add_another_answer">
      <a v-on:click="addAnotherAnswer()" class="color_1f95f2">Add another answer</a>
    </div>

    <div class="row">
      <div class="pt-15 fs-15 mb-20">
        <label class>
          <input type="checkbox" v-model="question.isDisplayOtherOptionContentField" />
          <span class="text-align">Add an "Other" answer option or comment field</span>
        </label>
      </div>
      <template v-if="question.isDisplayOtherOptionContentField">
        <div class="col-md-12" v-if="question.isDisplayOtherOptionContentField">
          <div class="ml-10">
            <b>Label</b>
          </div>
          <div class="ml-10 col-md-4 mb-20 pl-0">
            <b-form-input type="text" class="fs-15 form-control-sm mt-10 field-h40" v-model="question.otherOptionContentField" placeholder="Other" size="sm"></b-form-input>
          </div>
        </div>
        <div v-if="question.isDisplayOtherOptionContentField" class="ml-10 pt-15 fs-15 mb-20">
          <label class="ml-12">
            <input type="checkbox" class v-model="question.isDisplayOtherCommentSelectedField" />
            <span class="text-align">Provide comment field if "Other" is selected</span>
          </label>
        </div>
        <div class="ml-10 col-md-12" v-if="question.isDisplayOtherCommentSelectedField">
          <div>
            <b>If left blank, display this error message:</b>
          </div>
          <div class="col-md-4 pt-5 pb-15 pl-0">
            <b-form-input type="text" class="fs-15 form-control mt-10 field-h40" v-model="question.otherCommentSelectedField" placeholder="Please enter a comment." size="sm"></b-form-input>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { IntegerPlusminus } from "vue-integer-plusminus";
import { v4 as uuidv4 } from "uuid";
import { quillEditor } from "vue-quill-editor";
import _ from "lodash";

export default {
  name: "ActivityStepDropdown",
  props: {
    question: {},
    showStep: { type: Boolean },
    mode: {
      default: "VIEW"
    },
    activityDetails: {},
    commonProps: {},
    editorOptionForHelp: {
      type: Object
    }
  },
  components: {
    IntegerPlusminus,
    quillEditor
  },
  data() {
    return {
      editorOptionForAnswers: {
        placeholder: "Enter answer choice",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], [{ align: [] }], ["clean"]]
        }
      },
      editorOptionForMessage: {
        placeholder: "Enter custom message text",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], ["clean"]]
        }
      },
      isAddHelpEnabled: false
    };
  },
  watch: {
    isAddHelpEnabled() {
      this.question.isAddHelpEnabled = this.isAddHelpEnabled;
    }
  },
  mounted() {
    this.isAddHelpEnabled = this.question.isAddHelpEnabled;
  },
  methods: {
    helpCharacterLimitValidation(event, maxCount = 250) {
      const helpContent = event.quill;
      if (event.text.length > maxCount) {
        this.$toastr.error(`Character limit cannot exceed ${maxCount}.`);
      }
      helpContent.deleteText(maxCount, helpContent.getLength());
    },
    validateAnswerLimit(dataOld) {
      let data = dataOld;
      data = this.stripHtml(data);
      if (this.question.type.toLowerCase() === "dropdown") {
        if (data.length > 36) {
          this.$toastr.error("Character limit reached.");
        }
      } else {
        if (data.length > 512) {
          this.$toastr.error("Character limit reached.");
        }
      }
    },
    deleteQuestionOptionItem(index) {
      // Toggle the 'isAddMessageEnabled' property
      this.question.options[index].isAddMessageEnabled = !this.question.options[index].isAddMessageEnabled;
      // Remove the option from the array
      this.question.options.splice(index, 1);
      // Update the sequence numbers for remaining options
      this.question.options.forEach((option, ind) => {
        option.sequence = ind + 1;
      });
      // If needed, force the component to re-render
      this.$forceUpdate();
    },
    deleteQuestionOptionMessageItem(options, index) {
      this.question.options[index].isAddMessageEnabled = !this.question.options[index].isAddMessageEnabled;
      this.$forceUpdate();
    },
    validateLabels(index) {
      const label = this.stripHtml(this.question.formattedLabels[index]);
      if (label && label.length > 35) {
        this.validLabels.push(index);
      } else {
        this.validLabels.forEach((item, vindex) => {
          if (item === index) {
            this.validLabels.splice(vindex, 1);
          }
        });
      }
    },
    addAnotherAnswer() {
      if (!this.question.options) {
        this.question.options = [];
      }
      let maxSequence = Number(_.max(_.map(this.question.options, "sequence")));
      if (!maxSequence) {
        maxSequence = this.question.options.length;
      }
      this.question.options.push({
        body: null,
        sequence: maxSequence + 1,
        nextQuestion: null,
        imageUrl: null,
        messageBody: null,
        isAddMessageEnabled: false
      });
      this.$forceUpdate();
    },
    stripHtml(content) {
      const temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = content;
      return temporalDivElement.innerText;
    },
    checkQuestionValidity() {
      const question = this.question;
      const errorObj = { isValid: true };
      if (!question.formattedBody || this.stripHtml(question.formattedBody).trim() == "") {
        errorObj.isValid = false;
        errorObj.msg = "Step is required.";
        return errorObj;
      }
      if (question.isAddHelpEnabled && (!question.hasOwnProperty("helpContent") || this.stripHtml(question.helpContent).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Help text is required for this step.";
        return errorObj;
      }

      let invalidAnswer = false;
      let answerLengthExceeded = false;

      _.forEach(question.options, value => {
        const answer = this.stripHtml(value.formattedBody);
        if (answer.length == 0) {
          invalidAnswer = true;
        }
        if (answer.length > 36) {
          answerLengthExceeded = true;
        }
        if (!value.formattedBody) {
          errorObj.isValid = false;
          errorObj.msg = "Step is required.";
          return errorObj;
        }
        if (invalidAnswer == false && answerLengthExceeded == false) {
          const uniqueOptionsArr = _.uniqBy(question.options, "formattedBody");
          if (uniqueOptionsArr.length < question.options.length) {
            errorObj.isValid = false;
            errorObj.msg = "Please populate all required fields and make sure answer options are not identical.";
            return errorObj;
          }
        }

        if ((value.messageBody == undefined || value.messageBody.trim() == "" || value.messageBody.trim().length == 0) && value.isAddMessageEnabled) {
          errorObj.isValid = false;
          errorObj.msg = "Message text is required for this step.";
          return errorObj;
        }
      });
      if (invalidAnswer == true) {
        errorObj.isValid = false;
        errorObj.msg = "Answer is required.";
        return errorObj;
      }
      if (answerLengthExceeded == true) {
        errorObj.isValid = false;
        errorObj.msg = "Character limit reached (36)";
        return errorObj;
      }

      if (!errorObj.isValid) {
        return errorObj;
      }

      if (question.hasBodyImage) {
        _.forEach(question.bodyImages, value => {
          if (!value.imageUrl) {
            errorObj.isValid = false;
            errorObj.msg = "Step is required.";
            return errorObj;
          }
        });
        if (!errorObj.isValid) {
          return errorObj;
        }
      }
      if (question.isDisplayOtherOptionContentField && (question.otherOptionContentField == null || question.otherOptionContentField.length == 0)) {
        errorObj.isValid = false;
        errorObj.msg = "Label is required.";
        return errorObj;
      }

      if (question.isDisplayOtherOptionContentField && this.question.otherOptionId == null) {
        this.question.otherOptionId = uuidv4();
      }

      if (question.isDisplayOtherCommentSelectedField && (question.otherCommentSelectedField == null || question.otherCommentSelectedField.length == 0)) {
        errorObj.isValid = false;
        errorObj.msg = "Comment is required.";
        return errorObj;
      }
      if (!question.isDisplayOtherOptionContentField) {
        delete this.question.otherOptionId;
        delete this.question.otherOptionContentField;
        delete this.question.otherCommentSelectedField;
        question.isDisplayOtherCommentSelectedField = false;
      }
      if (!question.isDisplayOtherCommentSelectedField) {
        delete this.question.otherCommentSelectedField;
      }
      return {
        isValid: Boolean(question.formattedBody && question.sequence && question.options.length > 1)
      };
    }
  }
};
</script>

<style scoped lang="scss">
.radio-option {
  margin: 0px;
  label {
    padding-left: 5px;
  }
}
.integer-plus-minus-input {
  width: 2rem;
  border: none;
  text-align: center;
}
.read-only {
  background-color: #ffffff;
  border: 2px solid #d3dfe4;
  color: #b0bac9;
}
.th-activity-question-type-multichoice-edit {
  position: relative;
  .add-message-text {
    position: absolute;
    z-index: 9;
    right: 566.5px;
    top: -7px;
    padding: 12px 13px;
    background-color: rgba(211, 223, 228, 0.5);
    font-size: 12px;
    color: #000000;
    font-weight: normal;
    line-height: 1.33;
    cursor: pointer;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;

    @media (min-width: 1600px) {
      right: 575px;
    }
  }
}
.btn-link.color_red {
  margin-left: -8px;
}
.add_message_div {
  margin-top: -8px;
}
.activity-configurator-step-edit-mode {
  .form-group {
    margin-bottom: 20px;
  }
}
.add-help-text {
  right: 533px;
  padding: 12px 13px;
  top: -38px;
}
</style>
